<template>
  <div class="min-h-screen relative">
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="min-h-screen container mx-auto max-w-[1200px] w-full mb-10 py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <!-- new -->
      <div class="p-4">
        <div class="flex justify-end">
          <button
            @click="$router.go(-1)"
            class="cursor-pointer bg-blues text-white hover:bg-[#18469d] hover:text-white px-3 py-1 text-sm font-bold rounded-2xl"
          >
            Back
          </button>
        </div>
        <div class="6 my-6">
          <div class="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 text-indigo-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>

            <h1 class="text-xl font-bold text-slate-900">
              {{ this.student_email }}
            </h1>
          </div>
        </div>
        <div class="flex items-center gap-8 border-b border-slate-200 mb-8">
          <button
            @click="activeTab = 'preview'"
            :class="[
              'relative pb-4 text-sm font-bold tracking-tight transition-all duration-200 outline-none',
              activeTab === 'preview'
                ? 'text-blue-600'
                : 'text-slate-500 hover:text-slate-800',
            ]"
          >
            <span>Student Preview</span>

            <div
              v-if="activeTab === 'preview'"
              class="absolute bottom-[-1px] left-0 right-0 h-[3px] bg-blue-600 rounded-t-full shadow-[0_-1px_4px_rgba(37,99,235,0.3)]"
            ></div>
          </button>

          <button
            @click="activeTab = 'mapping'"
            :class="[
              'relative pb-4 text-sm font-bold tracking-tight transition-all duration-200 outline-none',
              activeTab === 'mapping'
                ? 'text-blue-600'
                : 'text-slate-500 hover:text-slate-800',
            ]"
          >
            <span>Student Mapping</span>

            <div
              v-if="activeTab === 'mapping'"
              class="absolute bottom-[-1px] left-0 right-0 h-[3px] bg-blue-600 rounded-t-full shadow-[0_-1px_4px_rgba(37,99,235,0.3)]"
            ></div>
          </button>
        </div>
        <div v-if="activeTab === 'preview'">
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else>
            <div v-if="this.sem_course.length > 0">
              <div class="flex flex-wrap gap-2 mb-4">
                <template v-for="tab in sem_course">
                  <button
                    v-if="tab.semester === this.student_sem"
                    :key="tab.semester"
                    class="px-4 py-2 rounded text-sm transition duration-200 bg-blues text-white"
                  >
                    Semester<b class="pl-1">{{ tab.semester }}</b>
                  </button>
                </template>
              </div>

              <div>
                <div class="flex flex-row items-center justify-between">
                  <p
                    class="text-[#0F172A] text-lg sm:text-xl md:text-xl font-semibold"
                  >
                    My Courses
                    <span class="text-[16px]" v-if="this.sem_course[0].course">
                      ({{ this.sem_course[0].course.length }})</span
                    >
                  </p>
                </div>

                <div class="">
                  <div>
                    <div
                      v-if="sem_course[0]"
                      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6"
                    >
                      <div
                        v-for="course in sem_course[0].course"
                        :key="course.id"
                        class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto flex flex-col"
                      >
                        <router-link
                          :to="{
                            name: 'InstructorStudents',
                            params: {
                              course_id: course.id,
                              department_id: sem_course[0].department.id,
                            },
                          }"
                          class="relative flex justify-center items-center rounded-lg overflow-hidden"
                        >
                          <img
                            v-if="course.thumbnail"
                            class="object-cover h-[180px] sm:h-[200px] w-full"
                            :src="course.thumbnail"
                            alt="Course Thumbnail"
                          />
                          <img
                            v-else
                            class="object-cover h-[180px] sm:h-[200px] w-full"
                            :src="placeholder"
                            alt="Placeholder"
                          />
                        </router-link>

                        <div class="text-left flex flex-col gap-2 mt-2 flex-1">
                          <h3
                            class="text-base font-bold text-slate-800 truncate mb-1"
                          >
                            {{ course.title }}
                          </h3>
                          <p
                            class="text-xs font-medium text-slate-500 mb-2 uppercase tracking-tight"
                          >
                            Code: {{ course.course_code }}
                          </p>

                          <p
                            v-if="course.instructor"
                            class="text-xs sm:text-sm text-gray-600 mb-2"
                          >
                            <span class="font-bold">Instructor Name:</span>
                            {{ course.instructor }}
                          </p>

                          <div class="flex items-center gap-2 mt-2">
                            <input
                              type="checkbox"
                              :checked="course.is_published"
                              @click.stop
                              @change="togglePublish(course)"
                              class="w-4 h-4 cursor-pointer"
                            />
                            <!-- <span class="text-[11px] font-bold uppercase">
                              {{
                                course.is_published
                                  ? "Published"
                                  : "Unpublished"
                              }}
                            </span> -->

                            <label for="Published" class="text-sm"
                              >Published</label
                            >
                          </div>

                          <router-link
                            :to="{
                              name: 'InstructorStudents',
                              params: {
                                course_id: course.id,
                                department_id: sem_course[0].department.id,
                              },
                            }"
                            class="mt-auto"
                          >
                            <button
                              class="w-full mt-3 py-2 bg-slate-100 hover:bg-blue-600 hover:text-white text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                            >
                              Continue Learning
                            </button>
                          </router-link>

                          <!-- <button
                            @click="getDashboardOrPreviewUp(course)"
                            class="w-full mt-3 py-2 bg-slate-100 hover:bg-blue-600 hover:text-white text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                          >
                            Continue Learning
                          </button> -->
                           <!-- <router-link
                            :to="{
                              name: 'PreviewMyCourse',
                              params: {
                                course_id: course.id,
                              },
                            }"
                             @click="getDashboardOrPreviewUp(course)"
                            class="mt-auto"
                          >
                            <button
                              class="w-full mt-3 py-2 bg-slate-100 hover:bg-blue-600 hover:text-white text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                            >
                              Continue Learning
                            </button>
                          </router-link> -->
                        </div>
                      </div>

                      <div
                        v-if="this.sem_course[0].course.length == 0"
                        class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
                      >
                        <p class="text-sm">No Courses</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="flex justify-center w-full sm:p-6 h-auto">
              <p class="text-sm">No Semesters</p>
            </div>
          </div>
        </div>
        <div v-if="activeTab === 'mapping'">
          <StudentMapping
            :student_id="student_id"
            @trigger="this.getsemestercourse"
          />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Admin/Header.vue";
import StudentMapping from "@/components/Admin/StudentMapping.vue";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  data() {
    return {
      selectedcontent: "Courses",
      loading: true,
      activeTab: null,
      sem_course: [],
      activeTab: "preview",
      messages: {
        text: "",
        type: "null",
      },
      student_email: "",
    };
  },
  props: ["student_id", "student_sem","student_dep", "email","token"],

  components: {
    Header,
    Footer,
    StudentMapping,
    FlashMessage,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    this.getsemestercourse();
    this.student_email = this.$route.params.email;
    if (!localStorage.getItem("previewIgnoreList")) {
      localStorage.setItem("previewIgnoreList", JSON.stringify([]));
    }
  },

  async created() {},

  methods: {
    getDashboardOrPreviewUp(el) {
       this.$store.dispatch("student/saveStudentData", {
        token: this.token,
        email:this.email,
        studentId:this.student_id,
        semesterId: this.student_sem,
        department: this.student_dep
      })
      // if (localStorage.getItem("previewIgnoreList")) {
      //   let preList = new Set(
      //     JSON.parse(localStorage.getItem("previewIgnoreList")),
      //   );

      //   if (preList.size != 0) {
      //     if (preList.has(el.id.toString())) {
      //       this.$router.push({
      //         name: "PreviewStudentCourseProgress",
      //         params: { course_id:el.id },
      //       });
      //     } else {
      //       this.$router.push({
      //         name: "PreviewStudentCourse",
      //         params: { courseid: el.id },
      //       });
      //     }
      //   } else {
      //     this.$router.push({
      //       name: "PreviewStudentCourse",
      //       params: { courseid: el.id },
      //     });
      //   }
      // } else {
      //   this.$router.push({
      //     name: "PreviewStudentCourse",
      //     params: { courseid: el.id },
      //   });
      // }
    },
    isPublished(course) {
      return course.is_published;
    },
    async getsemestercourse() {
      this.loading = true;
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.student_id}/?semester__id=${this.student_sem}&Key=${this.userInfo.token_key}`,
        );

        if (res.data.data.status === 200) {
          this.sem_course = res.data.data.data[0].semester;
          this.sem_student = res.data.data.data[0];

          this.sem_course[0].course.forEach((course) => {
            if (
              course.published_course &&
              typeof course.published_course === "object"
            ) {
              course.is_published = Boolean(course.published_course.published);
              course.published_id = course.published_course.id;
            } else {
              course.is_published = Boolean(course.published_course);
              course.published_id = null;
            }
          });
        }
      } catch (err) {
        console.error("Error fetching semester courses:", err);
      } finally {
        this.loading = false;
      }
    },

    async togglePublish(course) {
      const id = course.published_id;
      const newStatus = !course.is_published;

      try {
        const response = await axios.patch(
          `${process.env.VUE_APP_API}/student_course/update/${
            id || course.id
          }/?Key=${this.userInfo.token_key}`,
          { id: id || course.id, published: newStatus },
        );

        course.is_published = newStatus;

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 2500);
        } else {
          this.messages = {
            text: response.data.message,
            type: "error",
          };
          setTimeout(() => {
            this.messages = { text: "", type: "null" };
          }, 2000);
        }
      } catch (err) {
        console.error("Publish toggle failed:", err);
        this.messages = {
          text: "Something went wrong while updating publish status.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "null" };
          this.loading = false;
        }, 2000);
      }
    },
  },
};
</script>

<style scoped></style>
